import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContextMenuComponent } from './contextmenu.component';
/**
 * NgModule definition for the ContextMenu component.
 */
export class ContextMenuModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    declarations: [
        ContextMenuComponent
    ],
    exports: [
        ContextMenuComponent
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ContextMenuModule_tsickle_Closure_declarations() {
/** @type {?} */
ContextMenuModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ContextMenuModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
